import {
  IGetBeneficiaryBatchHistorySort,
  IGetBeneficiaryBatchHistorySortBy,
} from '@smiles/voebiz-core-beneficiaries/dist/Types/BeneficiaryBatchHistoryApi.types';
import { Dropdown, DropdownOptions } from 'components/Dropdown';
import BaggageIcon from 'components/Icons/BaggageIcon';
import { useHistoryBatch } from 'contexts/HistoryBatch';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { historySort } from 'utils/dropdownLabels';
import HistoryBatchSearch from '../HistoryBatchSearch';

export const HistoryBatchFilterMobile = () => {
  const { isEmpty, setFilter, filter, isEmptyFilter, tab } = useHistoryBatch();

  const isDeactivate = useMemo(() => tab === '_DS', [tab]);

  const { t } = useTranslation(['history']);

  const navigate = useNavigate();

  const [currentOrderBy, setCurrentOrderByt] = useState(filter?.sort);

  const [isVisible, setIsVisible] = useState(false);

  const handleSort = useCallback(
    (type: string, by: string) => {
      const sort = type as IGetBeneficiaryBatchHistorySort;
      const sortBy = by as IGetBeneficiaryBatchHistorySortBy;
      setIsVisible(false);
      setCurrentOrderByt(sort);
      setFilter({ sort, sortBy });
    },
    [setFilter, setIsVisible],
  );

  const sort = historySort;

  const optionsInclude = useMemo<DropdownOptions[]>(
    () =>
      sort.labels.map((item) => ({
        onClick: () => handleSort(item.sort, sort.type),
        label: item.label,
        checked: item.sort === currentOrderBy,
      })),
    [currentOrderBy, handleSort, sort.labels, sort.type],
  );

  const redirectToCreateBatch = useCallback(() => {
    navigate('?m=dropdown-modal-include');
  }, [navigate]);

  return (
    <>
      <HistoryBatchSearch />
      {isEmpty ? (
        <div className="empty-history">
          <BaggageIcon />
          <span>{isEmptyFilter ? t('no_file_found') : t('start_register')}</span>
          <span>{isEmptyFilter ? `${t('try_again_files')} \n` : t('start_register_text')}</span>
          {!isDeactivate && (
            <button type="button" className="reimport-button" onClick={redirectToCreateBatch}>
              {t('register_button')}
            </button>
          )}
        </div>
      ) : (
        <div className="button-wrapper-history beneficiaries-dropdown">
          <button className="show-more-button-mobile menu-trigger" type="button" onClick={() => setIsVisible(true)}>
            {t('order_by')}
            <span className="chevron-full" />
          </button>

          <Dropdown
            close={() => setIsVisible(false)}
            open={isVisible}
            options={optionsInclude}
            id="dropdown-sort-history-batch-mobile"
          />
        </div>
      )}
    </>
  );
};
